module.exports = "<!--<div class=\"preloader\">-->\n  <!--<svg class=\"circular\" viewBox=\"25 25 50 50\">-->\n    <!--<circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"/>-->\n  <!--</svg>-->\n<!--</div>-->\n<!-- ============================================================== -->\n<!-- Wrapper -->\n<!-- ============================================================== -->\n<app-loader></app-loader>\n\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main